<!--产品概述-->

<template>
    <div>
        <div class='child-body'>
            <div class='productOverviewTitle'>
                <div class="main-title">{{name}}</div>
                <div class="subtitle-title">{{data.title}}</div>
                <div class="subtitle-title-html">
                    {{data.html}}
                </div>
            </div>
            <div class='productOverview'>
                <img :src="data.img" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'index',
    props: ['data','name']
}
</script>
<style scoped>
.productOverviewTitle{
    /* height:210px; */

    padding: 50px 0;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #262626;
    text-align: center;
}
.subtitle-title{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #303133;
    line-height: 40px;
    margin-bottom: 20px;
}
.subtitle-title-html{
    width: 902px;
    margin: 0 auto;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909399;
    line-height: 30px;
}
.main-title{
    margin-bottom:12px;
}
.productOverview{
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
}

</style>